<template>
  <SysDialog v-model="dialog_ativo" :largura="950" ocultar-acoes>
    <template #ativador>
      <v-btn icon x-small :class="content_class || ''" @click="dialog_ativo = true;buscarAnaliseEstoqueProdutoPorFilial();">
        <v-icon :size="16">mdi-information-outline</v-icon>
      </v-btn>
    </template>


    <template #titulo>
      <div>
        <p class="ma-0 font-21">Análise DRP do estoque</p>
        <p class="ma-0 font-13 mt-n3 text-gray-900">{{ `PRODUTO: ${idproduto} - ${descricao_produto}` }}</p>
      </div>

      <v-spacer />

      <v-btn icon @click="dialog_ativo = false;produtos = [];">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <sys-data-table
      :height="Math.max(Math.min(450, (produtos.length * 45) + 33), 78)"
      :item-height="45"
      :headers="cabecalhos"
      :items="produtos"
      hide-default-footer
      class="mt-n3"
    >
      <template #item.filial="{item}">
        {{ item.filial }}
        <template v-if="item.descricao_filial"> - {{ item.descricao_filial }}</template>
      </template>

      <template #item.consumo_medio_mensal="{value}">{{ Helpers.formatarValor(value) }}</template>

      <template #item.estoque="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.cobertura_estoque="{value}">{{ Helpers.formatarValor(value) }} dias</template>

      <template #item.estoque_ideal="{value}">{{ Helpers.formatarValor(value) }}</template>
      <template #item.cobertura_estoque_ideal="{value}">{{ Helpers.formatarValor(value) }} dias</template>

      <template #item.diferenca_percentual="{item, value}">
        <div class="d-flex align-center ml-n1">
          <v-icon v-if="value > 0" :size="18" color="green">mdi-arrow-up</v-icon>
          <v-icon v-else-if="value < 0" :size="18" color="red">mdi-arrow-down</v-icon>
          <div v-else class="w-18" />

          <div class="text-center w-40 text-no-wrap">{{ Helpers.formatarValor(Math.abs(value)) }}%</div>
        </div>
      </template>
    </sys-data-table>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {logout} from "@/helpers";
import {buscarAnaliseEstoqueProdutoPorFilial} from "@/api/drp/Produto";

export default {
  name: "AnaliseDrpEstoqueFiliais",
  components: {
    SysDialog
  },
  props: {
    idgrupo: Number,
    idfilial: {
      type: Number,
      default: 0
    },
    idproduto: String,
    descricao_produto: String,
    content_class: String,
  },
  data: () => ({
    dialog_ativo: false,
    cabecalhos: [
      {text: "Filial", value: "filial"},
      {text: "Projeção de vendas", value: "consumo_medio_mensal"},
      {text: "Estoque atual", value: "estoque"},
      {text: "Cobertura atual", value: "cobertura_estoque"},
      {text: "Estoque ideal", value: "estoque_ideal"},
      {text: "Cobertura ideal", value: "cobertura_estoque_ideal"},
      {text: "Diferença", value: "diferenca_percentual"},
    ],
    produtos: []
  }),
  methods: {
    buscarAnaliseEstoqueProdutoPorFilial() {
      const parametros = {
        idgrupo: this.idgrupo,
        idfilial: this.idfilial,
        idproduto: this.idproduto,
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarAnaliseEstoqueProdutoPorFilial(parametros)
          .then(produtos => this.produtos = produtos)
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
